"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import { Retailer } from './Retailer';
// import { File } from 'parse';
// import { CustomerSupportRequest } from './CustomerSupportRequest';
// tslint:disable-next-line: no-namespace
var APIModel;
(function (APIModel) {
    let InteractionStatus;
    (function (InteractionStatus) {
        InteractionStatus["Waiting"] = "WAITING";
        InteractionStatus["Contacted"] = "CONTACTED";
        InteractionStatus["Finished"] = "FINISHED";
    })(InteractionStatus = APIModel.InteractionStatus || (APIModel.InteractionStatus = {}));
})(APIModel = exports.APIModel || (exports.APIModel = {}));
//# sourceMappingURL=APIModel.js.map